// this file is automatically generated by git.version.ts script
export const versionInfo = {
    version: 'main#36d9244',
};
